import React from "react";
import { withRouter } from "react-router-dom";
import algoliasearch from "algoliasearch";
import SegmentWrapper from "./SegmentWrapper";
import { trackViewEventsSearch } from "./tracking";
import { isBot } from "../Analytics/botDetection";

class RouteChangeHandler extends React.Component {
  componentDidUpdate(prevProps) {
    if (sessionStorage.getItem("segment_userId")) {
      if (this.props.location.pathname !== prevProps.location.pathname) {
        trackPageViews();
      }
      trackViewEventsSearch();
    }
  }

  componentDidMount() {
    const MAX_RETRIES = 10;
    let retryCount = 0;
    let checkInterval = setInterval(() => {
      retryCount++;
      if (sessionStorage.getItem("segment_userId")) {
        clearInterval(checkInterval);
        trackPageViews();
        trackViewEventsSearch();
      } else if (retryCount >= MAX_RETRIES) {
        clearInterval(checkInterval);
        sessionStorage.setItem("segment_userId", "anonymous");
        trackPageViews();
        trackViewEventsSearch();
      }
    }, 500);
  }

  render() {
    return <SegmentWrapper />;
  }
}

const trackViewEvent = (event) => {
  window.analytics.track("View Event Page", {
    event_title: event.title,
    event_program_number: event.content.match("(?<=#:).*$")[0],
    event_start_date: event.start_datetime,
    event_end_date: event.end_datetime,
    event_location: event.city + " " + event.state,
    event_type: event.pga_event_type,
    eligible_to_play: event.eligible_to_play.join(", "),
    event_registration_deadline: event.deadline_datetime,
    event_registration_status: isOpenOrClosed(event),
    page_url: window.location.href,
    page_path: window.location.href,
  });
};

const isOpenOrClosed = (event) => {
  const now = new Date();
  if (event.deadline_datetime < now) {
    return "Closed";
  } else {
    return "Open";
  }
};
const trackPageViews = () => {
  if (isBot()) {
    return;
  }

  const algoliaClient = algoliasearch(
    process.env.REACT_APP_ALGOLIA_APP_ID,
    process.env.REACT_APP_ALGOLIA_API_KEY,
  ).initIndex(process.env.REACT_APP_ALGOLIA_INDEX_NAME);
  if (
    window.location.href.includes("events") &&
    window.location.href.includes("pga") &&
    window.location.href.includes("/event/")
  ) {
    algoliaClient
      .search("", {
        filters: `slug:"${window.location.href.match("(?<=event/).*$")[0]}"`,
        distinct: true,
        hitsPerPage: 200,
      })
      .then((result) => {
        trackViewEvent(result.hits[0]);
      });
  } else if (
    window.analytics?.page &&
    window.location.href.includes("/search")
  ) {
    window.analytics.page();
  }
};

export default withRouter(RouteChangeHandler);
